import { kasseClient } from '@/js/helpers/backend-clients';
import { displayAxiosError, hideLoadingOverlay } from '@/js/helpers/utils';
import konstanten from '@/js/konstanten';
import router from '@/router';
import { setFile } from '@/plugins/axios';

export default {
  setErmittlungsstichtag({ commit }, ermittlungsstichtag) {
    commit('SET_ERMITTLUNGSSTICHTAG', ermittlungsstichtag);
  },
  setBaujahr({ commit }, baujahr) {
    const number = parseInt(baujahr);
    commit('SET_BAUJAHR', isNaN(number) ? undefined : number);
  },
  setKernsanierung({ commit }, kernsanierung) {
    commit('SET_KERNSANIERUNG', kernsanierung ? kernsanierung : false);
  },
  setJahrDerKernsanierung({ commit }, jahrDerKernsanierung) {
    const number = parseInt(jahrDerKernsanierung);
    commit('SET_JAHR_DER_KERNSANIERUNG', isNaN(number) ? undefined : number);
  },
  setWohnungsnummer({commit}, wohnungsnummer) {
    commit('SET_WOHNUNGSNUMMER', wohnungsnummer);
  },
  setAnzahlWohneinheiten({commit}, anzahlWohneinheiten) {
    const number = parseInt(anzahlWohneinheiten);
    commit('SET_ANZAHL_WOHNEINHEITEN', isNaN(number) ? undefined : number);
  },
  setAnzahlNutzeinheiten({commit}, anzahlNutzeinheiten) {
    const number = parseInt(anzahlNutzeinheiten);
    commit('SET_ANZAHL_NUTZEINHEITEN', isNaN(number) ? undefined : number);
  },
  setWohnflaeche({commit}, wohnflaeche) {
    const number = parseFloat(wohnflaeche);
    commit('SET_WOHNFLAECHE', isNaN(number) ? undefined : number);
  },
  setNutzflaeche({commit}, nutzflaeche) {
    const number = parseFloat(nutzflaeche);
    commit('SET_NUTZFLAECHE', isNaN(number) ? undefined : number);
  },

  setAussenwaendeModernisierung({ commit }, modernisierung) {
    commit('SET_AUSSENWAENDE_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setAussenwaendeJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_AUSSENWAENDE_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setAussenwaendeErlaeuterung({ commit }, erlaeuterung) {
    commit('SET_AUSSENWAENDE_ERLAEUTERUNG', erlaeuterung);
  },
  setAussenwaendeAussenansichtVorne({ commit }, aussenansichtVorne) {
    commit('SET_AUSSENWAENDE_AUSSENANSICHT_VORNE', aussenansichtVorne);
  },
  setAussenwaendeAussenansichtHinten({ commit }, aussenansichtHinten) {
    commit('SET_AUSSENWAENDE_AUSSENANSICHT_HINTEN', aussenansichtHinten);
  },
  setAussenwaendeOffensichtlicheSchaeden({ commit }, offensichtlicheSchaeden) {
    commit('SET_AUSSENWAENDE_OFFENSICHTLICHE_SCHAEDEN', offensichtlicheSchaeden);
  },
  setAussenwaendeZusatzfoto({ commit }, zusatzfoto) {
    commit('PUSH_AUSSENWAENDE_ZUSATZFOTO', zusatzfoto);
  },
  removeAussenwaendeZusatzfoto({ commit }, zusatzfoto) {
    commit('REMOVE_AUSSENWAENDE_ZUSATZFOTO', zusatzfoto);
  },

  setDachModernisierung({ commit }, modernisierung) {
    commit('SET_DACH_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setDachJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_DACH_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setDachErlaeuterung({ commit }, erlaeuterung) {
    commit('SET_DACH_ERLAEUTERUNG', erlaeuterung);
  },
  setDachDacheindeckungAussen({ commit }, dacheindeckungAussen) {
    commit('SET_DACH_DACHEINDECKUNG_AUSSEN', dacheindeckungAussen);
  },
  setDachDachgeschossInnen({ commit }, dachgeschossInnen) {
    commit('SET_DACH_DACHGESCHOSS_INNEN', dachgeschossInnen);
  },
  setDachOffensichtlicheSchaeden({ commit }, offensichtlicheSchaeden) {
    commit('SET_DACH_OFFENSICHTLICHE_SCHAEDEN', offensichtlicheSchaeden);
  },
  setDachZusatzfoto({ commit }, zusatzfoto) {
    commit('PUSH_DACH_ZUSATZFOTO', zusatzfoto);
  },
  removeDachZusatzfoto({ commit }, zusatzfoto) {
    commit('REMOVE_DACH_ZUSATZFOTO', zusatzfoto);
  },

  setFensterModernisierung({ commit }, modernisierung) {
    commit('SET_FENSTER_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setFensterJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_FENSTER_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setFensterErlaeuterung({ commit }, erlaeuterung) {
    commit('SET_FENSTER_ERLAEUTERUNG', erlaeuterung);
  },
  setFensterHauseingangstuer({ commit }, hauseingangstuer) {
    commit('SET_FENSTER_HAUSEINGANSTUER', hauseingangstuer);
  },
  setFensterFenster({ commit }, fenster) {
    commit('SET_FENSTER_FENSTER', fenster);
  },
  setFensterOffensichtlicheSchaeden({ commit }, offensichtlicheSchaeden) {
    commit('SET_FENSTER_OFFENSICHTLICHE_SCHAEDEN', offensichtlicheSchaeden);
  },
  setFensterZusatzfoto({ commit }, zusatzfoto) {
    commit('PUSH_FENSTER_ZUSATZFOTO', zusatzfoto);
  },
  removeFensterZusatzfoto({ commit }, zusatzfoto) {
    commit('REMOVE_FENSTER_ZUSATZFOTO', zusatzfoto);
  },

  setFussboedenModernisierung({ commit }, modernisierung) {
    commit('SET_FUSSBOEDEN_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setFussboedenJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_FUSSBOEDEN_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setFussboedenErlaeuterung({ commit }, erlaeuterung) {
    commit('SET_FUSSBOEDEN_ERLAEUTERUNG', erlaeuterung);
  },
  setFussboedenFussboden1({ commit }, fussboden1) {
    commit('SET_FUSSBOEDEN_FUSSBODEN1', fussboden1);
  },
  setFussboedenFussboden2({ commit }, fussboden2) {
    commit('SET_FUSSBOEDEN_FUSSBODEN2', fussboden2);
  },
  setFussboedenFussboden3({ commit }, fussboden3) {
    commit('SET_FUSSBOEDEN_FUSSBODEN3', fussboden3);
  },
  setFussboedenOffensichtlicheSchaeden({ commit }, offensichtlicheSchaeden) {
    commit('SET_FUSSBOEDEN_OFFENSICHTLICHE_SCHAEDEN', offensichtlicheSchaeden);
  },
  setFussboedenZusatzfoto({ commit }, zusatzfoto) {
    commit('PUSH_FUSSBOEDEN_ZUSATZFOTO', zusatzfoto);
  },
  removeFussboedenZusatzfoto({ commit }, zusatzfoto) {
    commit('REMOVE_FUSSBOEDEN_ZUSATZFOTO', zusatzfoto);
  },

  setInnenwaendeModernisierung({ commit }, modernisierung) {
    commit('SET_INNENWAENDE_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setInnenwaendeJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_INNENWAENDE_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setInnenwaendeErlaeuterung({ commit }, erlaeuterung) {
    commit('SET_INNENWAENDE_ERLAEUTERUNG', erlaeuterung);
  },
  setInnenwaendeInnentuer1({ commit }, innentuer1) {
    commit('SET_INNENWAENDE_INNENTUER1', innentuer1);
  },
  setInnenwaendeInnentuer2({ commit }, innentuer2) {
    commit('SET_INNENWAENDE_INNENTUER2', innentuer2);
  },
  setInnenwaendeInnenwand1({ commit }, innenwand1) {
    commit('SET_INNENWAENDE_INNENWAND1', innenwand1);
  },
  setInnenwaendeInnenwand2({ commit }, innenwand2) {
    commit('SET_INNENWAENDE_INNENWAND2', innenwand2);
  },
  setInnenwaendeInnenwand3({ commit }, innenwand3) {
    commit('SET_INNENWAENDE_INNENWAND3', innenwand3);
  },
  setInnenwaendeOffensichtlicheSchaeden({ commit }, offensichtlicheSchaeden) {
    commit('SET_INNENWAENDE_OFFENSICHTLICHE_SCHAEDEN', offensichtlicheSchaeden);
  },
  setInnenwaendeZusatzfoto({ commit }, zusatzfoto) {
    commit('PUSH_INNENWAENDE_ZUSATZFOTO', zusatzfoto);
  },
  removeInnenwaendeZusatzfoto({ commit }, zusatzfoto) {
    commit('REMOVE_INNENWAENDE_ZUSATZFOTO', zusatzfoto);
  },

  setDeckenModernisierung({ commit }, modernisierung) {
    commit('SET_DECKEN_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setDeckenJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_DECKEN_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setDeckenErlaeuterung({ commit }, erlaeuterung) {
    commit('SET_DECKEN_ERLAEUTERUNG', erlaeuterung);
  },
  setDeckenTreppe1({ commit }, treppe1) {
    commit('SET_DECKEN_TREPPE1', treppe1);
  },
  setDeckenTreppe2({ commit }, treppe2) {
    commit('SET_DECKEN_TREPPE2', treppe2);
  },
  setDeckenDeckenkonstruktion1({ commit }, deckenkonstruktion1) {
    commit('SET_DECKEN_DECKENKONSTRUKTION1', deckenkonstruktion1);
  },
  setDeckenDeckenkonstruktion2({ commit }, deckenkonstruktion2) {
    commit('SET_DECKEN_DECKENKONSTRUKTION2', deckenkonstruktion2);
  },
  setDeckenOffensichtlicheSchaeden({ commit }, offensichtlicheSchaeden) {
    commit('SET_DECKEN_OFFENSICHTLICHE_SCHAEDEN', offensichtlicheSchaeden);
  },
  setDeckenZusatzfoto({ commit }, zusatzfoto) {
    commit('PUSH_DECKEN_ZUSATZFOTO', zusatzfoto);
  },
  removeDeckenZusatzfoto({ commit }, zusatzfoto) {
    commit('REMOVE_DECKEN_ZUSATZFOTO', zusatzfoto);
  },

  setSanitaerModernisierung({ commit }, modernisierung) {
    commit('SET_SANITAER_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setSanitaerJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_SANITAER_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setSanitaerErlaeuterung({ commit }, erlaeuterung) {
    commit('SET_SANITAER_ERLAEUTERUNG', erlaeuterung);
  },
  setSanitaerBad1({ commit }, bad1) {
    commit('SET_SANITAER_BAD1', bad1);
  },
  setSanitaerBad2({ commit }, bad2) {
    commit('SET_SANITAER_BAD2', bad2);
  },
  setSanitaerOffensichtlicheSchaeden({ commit }, offensichtlicheSchaeden) {
    commit('SET_SANITAER_OFFENSICHTLICHE_SCHAEDEN', offensichtlicheSchaeden);
  },
  setSanitaerZusatzfoto({ commit }, zusatzfoto) {
    commit('PUSH_SANITAER_ZUSATZFOTO', zusatzfoto);
  },
  removeSanitaerZusatzfoto({ commit }, zusatzfoto) {
    commit('REMOVE_SANITAER_ZUSATZFOTO', zusatzfoto);
  },

  setHeizungModernisierung({ commit }, modernisierung) {
    commit('SET_HEIZUNG_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setHeizungJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_HEIZUNG_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setHeizungErlaeuterung({ commit }, erlaeuterung) {
    commit('SET_HEIZUNG_ERLAEUTERUNG', erlaeuterung);
  },
  setHeizungHeizungsanlage1({ commit }, heizungsanlage1) {
    commit('SET_HEIZUNG_HEIZUNGSANLAGE1', heizungsanlage1);
  },
  setHeizungHeizungsanlage2({ commit }, heizungsanlage2) {
    commit('SET_HEIZUNG_HEIZUNGSANLAGE2', heizungsanlage2);
  },
  setHeizungOffensichtlicheSchaeden({ commit }, offensichtlicheSchaeden) {
    commit('SET_HEIZUNG_OFFENSICHTLICHE_SCHAEDEN', offensichtlicheSchaeden);
  },
  setHeizungZusatzfoto({ commit }, zusatzfoto) {
    commit('PUSH_HEIZUNG_ZUSATZFOTO', zusatzfoto);
  },
  removeHeizungZusatzfoto({ commit }, zusatzfoto) {
    commit('REMOVE_HEIZUNG_ZUSATZFOTO', zusatzfoto);
  },

  setTechnischeAusstattungModernisierung({ commit }, modernisierung) {
    commit('SET_TECHNISCHE_AUSSTATTUNG_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setTechnischeAusstattungJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit(
      'SET_TECHNISCHE_AUSSTATTUNG_JAHR_DER_MODERNISIERUNG',
      isNaN(number) ? undefined : number,
    );
  },
  setTechnischeAusstattungErlaeuterung({ commit }, erlaeuterung) {
    commit('SET_TECHNISCHE_AUSSTATTUNG_ERLAEUTERUNG', erlaeuterung);
  },
  setTechnischeAusstattungSicherungskasten({ commit }, sicherungskasten) {
    commit('SET_TECHNISCHE_AUSSTATTUNG_SICHERUNGSKASTEN', sicherungskasten);
  },
  setTechnischeAusstattungSteckdosen({ commit }, steckdosen) {
    commit('SET_TECHNISCHE_AUSSTATTUNG_STECKDOSEN', steckdosen);
  },
  setTechnischeAusstattungOffensichtlicheSchaeden({ commit }, offensichtlicheSchaeden) {
    commit('SET_TECHNISCHE_AUSSTATTUNG_OFFENSICHTLICHE_SCHAEDEN', offensichtlicheSchaeden);
  },
  setTechnischeAusstattungZusatzfoto({ commit }, zusatzfoto) {
    commit('PUSH_TECHNISCHE_AUSSTATTUNG_ZUSATZFOTO', zusatzfoto);
  },
  removeTechnischeAusstattungZusatzfoto({ commit }, zusatzfoto) {
    commit('REMOVE_TECHNISCHE_AUSSTATTUNG_ZUSATZFOTO', zusatzfoto);
  },

  setObjektunterlagenGrundriss({ commit }, grundriss) {
    commit('SET_OBJEKTUNTERLAGEN_GRUNDRISS', grundriss);
  },
  setObjektunterlagenZusatzdokumentGrundriss({ commit }, zusatzdokumentGrundriss) {
    commit('SET_OBJEKTUNTERLAGEN_ZUSATZDOKUMENT_GRUNDRISS', zusatzdokumentGrundriss);
  },
  setObjektunterlagenEnergieausweis({ commit }, energieausweis) {
    commit('SET_OBJEKTUNTERLAGEN_ENERGIEAUSWEIS', energieausweis);
  },
  setObjektunterlagenZusatzdokumentEnergieausweis({ commit }, zusatzdokumentEnergieausweis) {
    commit('SET_OBJEKTUNTERLAGEN_ZUSATZDOKUMENT_ENERGIEAUSWEIS', zusatzdokumentEnergieausweis);
  },

  setAnsprechpartnerVorname({ commit }, vorname) {
    commit('SET_ANSPRECHPARTNER_VORNAME', vorname);
  },
  setAnsprechpartnerNachname({ commit }, nachname) {
    commit('SET_ANSPRECHPARTNER_NACHNAME', nachname);
  },
  setAnsprechpartnerTelefon({ commit }, telefon) {
    commit('SET_ANSPRECHPARTNER_TELEFON', telefon);
  },
  setAnsprechpartnerErlaeuterung({ commit }, erlaeuterung) {
    commit('SET_ANSPRECHPARTNER_ERLAEUTERUNG', erlaeuterung);
  },

  setDefaultRechnungName1({ commit }, name1) {
    commit('SET_DEFAULT_RECHNUNG_NAME1', name1);
  },
  setDefaultRechnungName2({ commit }, name2) {
    commit('SET_DEFAULT_RECHNUNG_NAME2', name2);
  },
  setDefaultRechnungPlz({ commit }, plz) {
    commit('SET_DEFAULT_RECHNUNG_PLZ', plz);
  },
  setDefaultRechnungOrt({ commit }, ort) {
    commit('SET_DEFAULT_RECHNUNG_ORT', ort);
  },
  setDefaultRechnungStr({ commit }, str) {
    commit('SET_DEFAULT_RECHNUNG_STR', str);
  },
  setDefaultRechnungHnr({ commit }, hnr) {
    commit('SET_DEFAULT_RECHNUNG_HNR', hnr);
  },


  setUseDefaultRechnungData({ commit }, useDefaultRechnungData) {
    commit('SET_USE_DEFAULT_RECHNUNG_DATA', useDefaultRechnungData);
  },
  setAlternativeRechnungName1({ commit }, name1) {
    commit('SET_ALTERNATIVE_RECHNUNG_NAME1', name1);
  },
  setAlternativeRechnungName2({ commit }, name2) {
    commit('SET_ALTERNATIVE_RECHNUNG_NAME2', name2);
  },
  setAlternativeRechnungPlz({ commit }, plz) {
    commit('SET_ALTERNATIVE_RECHNUNG_PLZ', plz);
  },
  setAlternativeRechnungOrt({ commit }, ort) {
    commit('SET_ALTERNATIVE_RECHNUNG_ORT', ort);
  },
  setAlternativeRechnungStr({ commit }, str) {
    commit('SET_ALTERNATIVE_RECHNUNG_STR', str);
  },
  setAlternativeRechnungHnr({ commit }, hnr) {
    commit('SET_ALTERNATIVE_RECHNUNG_HNR', hnr);
  },

  reset({ commit }) {
    commit('RESET_STATE');
  },
  loadGutachten({ state, commit, dispatch }, saved) {
    commit('RESET_STATE');
    let unwrap = ({ modernisierung, jahrDerModernisierung, erlaeuterung }) => ({
      modernisierung,
      jahrDerModernisierung,
      erlaeuterung,
    });
    const {
          data: {
            produkt,
            adresse,
            allgemeineAngaben,
            aussenwaende,
            dach,
            fenster,
            fussboeden,
            innenwaende,
            decken,
            sanitaer,
            heizung,
            technischeAusstattung,
            ansprechpartner,
            objektunterlagen,
            alternativeRechnung
          },
        } = saved;

    Object.assign(state.allgemeineAngaben, allgemeineAngaben);
    Object.assign(state.aussenwaende, unwrap(aussenwaende));
    Object.assign(state.dach, unwrap(dach));
    Object.assign(state.fenster, unwrap(fenster));
    Object.assign(state.fussboeden, unwrap(fussboeden));
    Object.assign(state.innenwaende, unwrap(innenwaende));
    Object.assign(state.decken, unwrap(decken));
    Object.assign(state.sanitaer, unwrap(sanitaer));
    Object.assign(state.heizung, unwrap(heizung));
    Object.assign(state.technischeAusstattung, unwrap(technischeAusstattung));
    Object.assign(state.ansprechpartner, ansprechpartner);
    Object.assign(state.defaultRechnung, produkt.defaultRechnung);
    Object.assign(state.alternativeRechnung, alternativeRechnung);
    state.ausSpeicherGeladen = true;

    commit('kasse/UPDATE_WARENKORB_PRODUKTE', [produkt], { root: true });
    commit('address/UPDATE_CURRENT_ADDRESS', adresse, { root: true });
    let promises = [];
    for (const [key, value] of Object.entries({
      aussenwaende,
      dach,
      fenster,
      fussboeden,
      innenwaende,
      decken,
      sanitaer,
      heizung,
      technischeAusstattung,
    })) {
      promises.push(
        ...value.fotos.map(f => {
          return kasseClient.downloadFile('ndgmfh', f).then(response => {
            setFile(response, 'ndgmfh', f, undefined, d => {
              state[key].fotos[konstanten.IMAGE_MAP[key][f]] = d;
            });
          });
        }),
      );
      for (let i = 0; i < value.zusatzFotos; i++) {
        promises.push(
          kasseClient
            .downloadIndexFile('ndgmfh', konstanten.IMAGE_MAP[key].zusatzfoto, i)
            .then(response => {
              setFile(response, 'ndgmfh', konstanten.IMAGE_MAP[key].zusatzfoto, i, d => {
                state[key].fotos.zusatzfoto.push(d);
              });
            }),
        );
      }
    }
    promises.push(
      ...objektunterlagen.map(f => {
        return kasseClient.downloadFile('ndgmfh', f).then(response => {
          setFile(response, 'ndgmfh', f, undefined, d => {
            state.objektunterlagen[konstanten.IMAGE_MAP.objektunterlagen[f]] = d;
          });
        });
      }),
    );
    Promise.all(promises).then(_ => {
      router.push('/konfiguration/ndg');
    })
    .catch(error => displayAxiosError(error))
    .finally(() => hideLoadingOverlay());
  },
};
